import { ArrowLeft } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils";

type BackButtonProps = {
  onClick: () => void;
  className?: string;
  "aria-label"?: string;
};

export function BackButton({ onClick, className, "aria-label": ariaLabel }: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel ?? "Back"}
      className={cn("p-1 rounded-xl hover:bg-muted active:scale-95 transition cursor-pointer", className)}
    >
      <ArrowLeft className="w-6 h-6 sm:w-5 sm:h-5" />
    </button>
  );
}
